import { useEffect, useRef, useState } from "react";
import { useBoolean } from "./useBoolean";

export function useSectionFloodDetect({ itemClassName, singleLineHeight = "" }: { itemClassName: string; singleLineHeight?: string }) {
  const isMoreViewOpened = useBoolean(false);
  const isSectionFlooded = useBoolean(false);
  const [floodDectectIndex, setFloodDectectIndex] = useState<number>(-1);

  const divContainerRef = useRef<HTMLDivElement>(null);

  const onMoreViewOpenChange = (isOpended: boolean) => {
    isMoreViewOpened.setValue(isOpended);

    if (divContainerRef.current) {
      const el = divContainerRef.current;
      el.style.maxHeight = isOpended ? el?.scrollHeight + "px" : singleLineHeight;
    }
  };

  useEffect(() => {
    const detectItemEscaped = () => {
      if (divContainerRef.current) {
        const items = divContainerRef.current.querySelectorAll(itemClassName);
        if (!items?.length) return;

        const firstItemTop = (items[0] as HTMLElement).offsetTop;
        const floodIndex = Array.from(items).findIndex((item) => (item as HTMLElement).offsetTop > firstItemTop);

        if (floodIndex !== -1) {
          setFloodDectectIndex(floodIndex);
          isSectionFlooded.onTrue();
          return;
        }

        setFloodDectectIndex(-1);
        isSectionFlooded.onFalse();
      }
    };

    detectItemEscaped();
    window.addEventListener("resize", () => detectItemEscaped());

    if (divContainerRef.current) {
      const el = divContainerRef.current;
      el.style.maxHeight = singleLineHeight;
    }

    return () => window.removeEventListener("resize", detectItemEscaped);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { isMoreViewOpened, isSectionFlooded, floodDectectIndex, divContainerRef, onMoreViewOpenChange };
}
